export default __webpack_public_path__ + "static/media/hospital-building.e5de1498.svg";